module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("已审核老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "auditName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.auditName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditName", $$v)
      },
      expression: "queryParam.auditName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminNickname",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminNickname", $$v)
      },
      expression: "queryParam.adminNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人邮箱"
    }
  }, [_c('Input', {
    attrs: {
      "name": "adminMobile",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.adminMobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adminMobile", $$v)
      },
      expression: "queryParam.adminMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", _vm._n($$v))
      },
      expression: "queryParam.status"
    }
  }, _vm._l((_vm.filteredTeacherStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "未通过类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onRejectFailKindChange
    },
    model: {
      value: (_vm.queryParam.rejectFailKind),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "rejectFailKind", $$v)
      },
      expression: "queryParam.rejectFailKind"
    }
  }, [_c('Option', {
    attrs: {
      "value": "interview"
    }
  }, [_vm._v("面试未通过")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "demo"
    }
  }, [_vm._v("试讲未通过")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师国籍"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.country),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "country", $$v)
      },
      expression: "queryParam.country"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师口音"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师性别"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "种族"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ethnicity", $$v)
      },
      expression: "queryParam.ethnicity"
    }
  }, [_c('Option', {
    attrs: {
      "value": "African"
    }
  }, [_vm._v("African")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Coloured"
    }
  }, [_vm._v("Coloured")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "White"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Indian/Asian"
    }
  }, [_vm._v("Indian/Asian")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "审核时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.auditDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', [_c('Co', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertTch
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showBatchReview
    }
  }, [_vm._v("批量审核")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/audited/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核通过"
    },
    model: {
      value: (_vm.showPassModal),
      callback: function($$v) {
        _vm.showPassModal = $$v
      },
      expression: "showPassModal"
    }
  }, [_c('Form', {
    ref: "passForm",
    staticClass: "form",
    attrs: {
      "model": _vm.passParam,
      "rules": _vm.passRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定允许 "), _c('b', [_vm._v(_vm._s(_vm.passParam.id) + " - " + _vm._s(_vm.passParam.firstName) + " " + _vm._s(_vm.passParam.lastName))]), _vm._v(" 老师通过审核，进入培训中")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.passParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.passParam, "remark", $$v)
      },
      expression: "passParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showPassModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingPass
    },
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("通过")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    staticClass: "form",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定 "), _c('b', [_vm._v(_vm._s(_vm.rejectParam.id) + " - " + _vm._s(_vm.rejectParam.firstName) + " " + _vm._s(_vm.rejectParam.lastName))]), _vm._v(" 老师未审核通过")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.rejectParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "remark", $$v)
      },
      expression: "rejectParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "批量审核"
    },
    model: {
      value: (_vm.showBatchReviewModal),
      callback: function($$v) {
        _vm.showBatchReviewModal = $$v
      },
      expression: "showBatchReviewModal"
    }
  }, [_c('Form', {
    ref: "reviewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.reviewParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "待审核老师："
    }
  }, _vm._l((_vm.selectionTch), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.reviewParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "remark", $$v)
      },
      expression: "reviewParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchPass')
      }
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.batchReview('batchReject')
      }
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.search,
      "recruit-flow-entry": "已审核老师列表"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9655560","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchAuditList.vue
// module id = 1938
// module chunks = 8